<template>
  <div>
    <h1 class="h3 mb-3 text-gray-800">{{ $t("Detalhes da Atividade") }}</h1>

    <loading-animation
      :active.sync="loading"
      :is-full-page="false"
      :opacity="1"
      color="#5895FF"
    />
    <div id="boxPrint" class="row">
      <div class="col-md-12">
        <print-content>
          <table
            class="table b-table b-table-stacked-xs table-bordered table-sm bg-white"
          >
            <tbody>
              <tr>
                <td>
                  ID: <strong>{{ item.id }}</strong>
                </td>
                <td>
                  PROTOCOLO: <strong>{{ item.protocolo }}</strong>
                </td>
                <td>
                  CADASTRADO:
                  <strong>{{ item.created_at }}</strong>
                </td>
                <td>
                  ATUALIZADO:
                  <strong>{{ item.updated_at }}</strong>
                </td>
              </tr>
              <tr v-if="item.responsavel && item.responsavel.tecnico">
                <td colspan="2">
                  TÉCNICO RESPONSÁVEL:
                  <strong>{{ item.responsavel.tecnico.nome }}</strong>
                  <span class="badge badge-light">{{
                    item.responsavel.tecnico.profissao ?? "Não informado"
                  }}</span>
                </td>
                <td colspan="2">
                  UNIDADE:
                  <strong>{{ item.unidade.nome }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  TÉCNICO AUTOR:
                  <b>{{ item.autor }}</b>
                </td>
              </tr>
              <tr v-if="item.atividadesable_type != 'Modules\\Scfv\\Entities\\ScfvGrupo'">
                <td colspan="4">
                  TÍTULO:
                  <strong>{{ item.titulo }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  TIPO:
                  <strong>{{ item.tipo }}</strong>
                </td>
                <td colspan="2">
                  STATUS:
                  <strong v-html="item.status_nome"></strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  DATA:
                  <strong>{{ item.data | formatDate() }}</strong>
                </td>
                <td>
                  HORA:
                  <strong>{{ item.hora_print }}</strong>
                </td>
                <td>
                  DURAÇÃO:
                  <strong>{{ item.duracao }}</strong>
                </td>
              </tr>
              <tr v-if="item.link_sala_reuniao !== ''">
                <td colspan="4">
                  LINK DA SALA VIRTUAL: {{ item.link_sala_reuniao }}
                </td>
              </tr>
              <tr v-if="item.atividadesable_type != 'Modules\\Scfv\\Entities\\ScfvGrupo'">
                <td colspan="4">
                  OBSERVAÇÃO:
                  <div v-html="item.conteudo"></div>
                </td>
              </tr>
              <tr>
                <td colspan="4" v-if="item.participantes_presentes" class="p-3">
                  <p class="small text-muted">
                    Técnicos, Usuários ou Usuários SCFV participantes desta
                    Atividade
                  </p>
                  <table
                    class="table b-table b-table-stacked-xs table-sm bg-white"
                    v-if="item.participantes_presentes.length > 0"
                  >
                    <thead>
                      <tr>
                        <th colspan="3" class="text-center">EQUIPE - PARTICIPANTES:</th>
                      </tr>
                      <tr>
                        <th></th>
                        <th>Nome</th>
                        <th style="width: 255px; min-width: 255px">
                          Assinatura
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(participante, index) in participantesValidos"
                        :key="participante.id || index"
                      >
                        <td width="27px">
                          <span v-if="item.participantes_presentes.includes(participante.id)">
                            <i class="fas fa-check"></i>
                          </span>
                          <span v-else>
                            <i class="fas fa-times"></i>
                          </span>
                        </td>
                        <td>
                          <b>{{ participante.nome }}</b>
                        </td>
                        <td width="255px" style="width: 255px; min-width: 255px"></td>
                      </tr>
                    </tbody>
                  </table>

                  <table
                    class="table b-table b-table-stacked-xs table-sm bg-white"
                    v-else
                  >
                    <thead>
                      <tr>
                        <th colspan="3" class="text-center">
                          <span
                            v-if="
                              item.atividadesable_type !=
                              'Modules\\Scfv\\Entities\\ScfvGrupo'
                            "
                            >TÉCNICOS</span
                          >
                          PARTICIPANTES:
                        </th>
                      </tr>
                      <tr>
                        <th></th>
                        <th>Nome</th>
                        <th style="width: 255px; min-width: 255px">
                          Assinatura
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(participante, index) in participantesValidos"
                        :key="participante.id || index"
                      >
                        <td width="27px"></td>
                        <td>{{ participante.nome }}</td>
                        <td width="255px" style="width: 255px; min-width: 255px"></td>
                      </tr>
                    </tbody>
                  </table>

                  <b-table
                    :fields="[
                      {
                        key: 'presenca',
                        label: '',
                      },
                      {
                        key: 'atividade',
                        label: $t('Nome'),
                      },
                      {
                        key: 'assinatura',
                        label: 'Assinatura',
                        thStyle: {
                          width: '255px',
                          minWidth: '255px',
                        },
                      },
                    ]"
                    :items="item.lista_inscritos"
                    :responsive="true"
                    hover
                    show-empty
                    small
                    outlined
                    stacked="md"
                    table-class="mb-3"
                    v-if="item.lista_inscritos.length > 0"
                  >
                    <template #thead-top="data">
                      <b-tr>
                        <b-th colspan="3" class="text-center"
                          >Usuários do Sistema Inscritos na Atividade</b-th
                        >
                      </b-tr>
                    </template>
                    <template v-slot:cell(presenca)="data">
                      <span v-if="data.value">
                        <i class="fas fa-check"></i>
                      </span>
                      <span v-else>
                        <i class="fas fa-times"></i>
                      </span>
                    </template>
                    <template v-slot:cell(atividade)="data">
                      <strong v-if="data.item.usuario">
                        {{ data.item.usuario.nome_completo }}
                      </strong>
                      <b
                        >{{
                          data.item.usuario.data_nascimento | calcIdade
                        }}
                        ano(s)</b
                      >
                    </template>
                    <template v-slot:cell()="data"> </template>
                    <template v-slot:empty="scope">
                      <div class="text-center my-5">
                        <img
                          :alt="$t('No results')"
                          class="mb-5"
                          src="/img/icons/robot.svg"
                          style="max-height: 165px"
                        />
                        <h3 class="bold">
                          {{ $t("No records found") }}
                        </h3>
                      </div>
                    </template>
                  </b-table>
                  <table
                    class="table b-table b-table-stacked-xs table-bordered table-sm bg-white"
                  >
                    <thead>
                      <tr>
                        <th colspan="3" class="text-center">
                          OUTROS PARTICIPANTES:
                        </th>
                      </tr>
                      <tr>
                        <th></th>
                        <th>Nome</th>
                        <th style="width: 255px; min-width: 255px">
                          Assinatura
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(key, index) in item.outros_participantes"
                        :key="item.outros_participantes[index]"
                      >
                        <td width="27px"></td>
                        <td>
                          <b>{{ item.outros_participantes[index] }}</b>
                        </td>
                        <td
                          width="255px"
                          style="width: 255px; min-width: 255px"
                        ></td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <td colspan="4">
                  USUÁRIOS SEM PRONTUÁRIO:
                  <b>{{ item.qtde_sem_printuario }}</b>
                </td>
              </tr>

            </tbody>
          </table>

          <table
            class="table b-table b-table-stacked-xs table-bordered table-sm bg-white"
            v-if="
              item.atividadesable_type === 'Modules\\Scfv\\Entities\\ScfvGrupo'
            "
          >
            <tbody>
              <tr>
                <td>
                  TEMA:<br />
                  <span v-html="item.tema"></span>
                </td>
              </tr>
              <tr>
                <td>
                  OBJETIVO ESPECÍFICO:<br />
                  <span v-html="item.objetivo_especifico"></span>
                </td>
              </tr>
              <tr>
                <td>
                  DINÂMICA/SINTESE DE DESENVOLVIMENTO:<br />
                  <span v-html="item.dinamica"></span>
                </td>
              </tr>
              <tr>
                <td>
                  MATERIAIS A SEREM UTILIZADOS:<br />
                  <span v-html="item.materiais_utilizados"></span>
                </td>
              </tr>
            </tbody>
          </table>
          <print-footer
            v-if="item.responsavel && item.responsavel.tecnico && item.responsavel.tecnico.assinatura_digital"
            :tecnico="item.responsavel.tecnico"
            class="mt-0"
            :assinatura="item.responsavel.tecnico.assinatura_digital"
            :wpp="wpp"
            :email="email"
          />
          <span
            class="mr-2"
            v-for="(tecnico, index) in item.participantes_array"
            :key="index"
            v-if="outrasAssinaturas"
          >
            <print-footer
              :tecnico="tecnico"
              class="mt-0"
              :assinatura="tecnico.assinatura_digital"
            />
          </span>

          <div class="row">
            <div class="col-md-12">
              <modulo-comentario module="Atividade" :id="$route.params.id" :showCommentForm="false"/>
            </div>
          </div>
        </print-content>
        <div class="row pt-4 px-0 d-flex justify-content-end no-print">
          <div class="col-auto px-2 text-right">
            <a class="btn btn-default" @click="$router.go(-1)">
              <i class="mdi mdi-arrow-left" />
            </a>

            <b-button
              :title="$t('Editar')"
              :to="'/dashboard/atividades/edit/' + item.id"
              type="button"
              v-b-tooltip.hover
              variant="success"
              v-if="
                item.user_id == $store.state.user.id &&
                item.atividadesable_type != 'Modules\\Scfv\\Entities\\ScfvGrupo'
              "
            >
              <i class="mdi mdi-square-edit-outline" />
            </b-button>

            <a class="btn btn-sm py-1 btn-primary" @click="print()">
              <i class="mdi mdi-printer mdi-18px" />
            </a>

            <form-toggle
                grid="12"
                mt="0"
                v-model="email"
                label="Email"
            />
            <form-toggle
                grid="12"
                mt="0"
                v-model="wpp"
                label="Telefone/WhatsApp"
            />
            <form-toggle
              grid="12"
              mt="0"
              v-model="outrasAssinaturas"
              label="Assinatura Técnico (a) Participante"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Show",
  data() {
    return {
      loading: true,
      item: {},
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      outrasAssinaturas: false,
      wpp: true,
      email: true,
      comentarios: null,
      module: "Atividade",
    };
  },
  mounted() {
    this.getItem();
    this.getComentarios();
  },
  computed: {
    participantesValidos() {
      return (this.item.participantes_array || []).filter(p => p && typeof p === 'object');
    }
  },
  methods: {
    getItem() {
      axios
        .get(`api/dashboard/atividades/${this.$route.params.id}`)
        .then((response) => {
          this.item = response.data.data;
          if (this.item.status == 21) {
            this.listapresenca = true;
          }
          this.loading = false;
        })
        .catch((error) => {
          this.$router.push("/dashboard/atividades/");
        });
    },
    getComentarios() {
      var model = this.model || this.module;
      axios
        .get(`api/dashboard/get/comentarios`, {
            param: {
                id: this.$route.params.id,
                module: this.module,
                model: model,
            }
        })
        .then((response) => {
            this.comentarios = response.data.data;
        })
        .finally(() => {
            this.loadingComentarios = false;
        });
    },
  },
};
</script>

<style></style>
